"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragQueryFieldSelector = exports.SortableQueryFieldSelector = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@dnd-kit/core");
const sortable_1 = require("@dnd-kit/sortable");
const utilities_1 = require("@dnd-kit/utilities");
const core_2 = require("@material-ui/core");
const QueryFieldSelector_1 = __importDefault(require("./QueryFieldSelector"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledHandleDiv = styled_components_1.default.div `
  display: flex;
  align-items: center;
  padding: 3px 0;
  margin: 0 4px 0 -4px;
  color: #aaa;
  cursor: move;
`;
// eslint-disable-next-line @typescript-eslint/ban-types
const SortableQueryFieldSelector = (_a) => {
    var { id, disabledDrag } = _a, props = __rest(_a, ["id", "disabledDrag"]);
    const { attributes, isDragging, listeners, setNodeRef, transform, transition } = (0, sortable_1.useSortable)({ id });
    const { active } = (0, core_1.useDndContext)();
    return (react_1.default.createElement(QueryFieldSelector_1.default, Object.assign({ innerRef: setNodeRef, disabled: Boolean(active), style: {
            // position: 'relative',
            // display: 'inline-block',
            opacity: isDragging ? 0.75 : undefined,
            transform: utilities_1.CSS.Translate.toString(transform),
            transition: transition || undefined
        } }, props, { prependElement: !disabledDrag && props.value ? (react_1.default.createElement(StyledHandleDiv, Object.assign({ className: 'drag-indicator' }, attributes, listeners, { tabIndex: -1 }),
            react_1.default.createElement(core_2.Icon, null, "drag_indicator"))) : undefined })));
};
exports.SortableQueryFieldSelector = SortableQueryFieldSelector;
// eslint-disable-next-line @typescript-eslint/ban-types
const DragQueryFieldSelector = (props) => {
    return (react_1.default.createElement(QueryFieldSelector_1.default, Object.assign({ disabled: true, style: {
            background: '#fff',
            opacity: 0.8,
            boxShadow: '0 3px 10px rgba(0, 0, 0, 0.1)'
        } }, props, { prependElement: react_1.default.createElement(StyledHandleDiv, { className: 'drag-indicator', tabIndex: -1 },
            react_1.default.createElement(core_2.Icon, null, "drag_indicator")) })));
};
exports.DragQueryFieldSelector = DragQueryFieldSelector;
//# sourceMappingURL=SortableQueryFieldSelector.js.map